import { render, staticRenderFns } from "./View.vue?vue&type=template&id=52ff3d32&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ff3d32')) {
      api.createRecord('52ff3d32', component.options)
    } else {
      api.reload('52ff3d32', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=52ff3d32&", function () {
      api.rerender('52ff3d32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Warehouse/orders/customer/View.vue"
export default component.exports